import { flatten as flattenInternal, unflatten as unflattenInternal } from 'flat';
import { isObject } from './object';

export const flatten = (obj: any): object => (isObject(obj) ? flattenInternal(obj) : obj);
export const unflatten = (obj: any): object => (isObject(obj) ? unflattenInternal(obj) : obj);
